<template>
  <div class="contact">
    <p><span class="dot" aria-hidden="true"></span>{{ t("Disponible pour des missions freelance", "Available for freelance work") }}</p>
    <a :href="`mailto:${email}`">{{ email }}</a>
  </div>
  <footer class="foot">
    <span>© {{ year }} Arolle Fona · Douala</span>
    <nav :aria-label="t('Pied de page', 'Footer')">
      <router-link v-for="item in menu" :key="item.key" :to="to(item.key)">{{ t(item.label) }}</router-link>
    </nav>
  </footer>
</template>

<script>
import { EMAIL } from "@/content";
import { MENU, useI18n } from "@/i18n";

export default {
  name: "SiteFooter",
  setup() {
    return { ...useI18n(), menu: MENU, email: EMAIL, year: new Date().getFullYear() };
  },
};
</script>
